module.exports = __webpack_public_path__ + "static/media/loc4_img3.e5d9c2be.jpg";